if($('.id--16').length){




}